'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/index.js
// module id = 930
// module chunks = 1